import gql from 'graphql-tag'
import { ItemPastaFragment } from './item-pasta-fragment'

export const GetItemsPorPastaQueryName = 'GetItemsPorPasta'
export const ITEMS_POR_PASTA_QUERY = gql`
  query GetItemsPorPasta($idPasta: ID) {
    itemsPorPasta(idPastaPai: $idPasta) {
      totalItems
      totalFiles
      totalFolders
      content {
        ...ItemPastaFragment
      }
    }
  }
  ${ItemPastaFragment}
`
